import { api } from "@services/api";
import type {
  BerthVisitedCode,
  CreateDeficiencyRequestPayload,
  DeficiencyCompany,
  DeficiencyCompletePayload,
  DeficiencyDetailsResponse,
  DeficiencyResolutionPayload,
  DeficiencySearchRequest,
  DeficiencySearchResponse,
} from "@services/deficiencies/types";

const SERVICE = "bff-deficiency";
const CREATE_DEFICIENCY_PATH = "deficiencies";
const SEARCH_DEFICIENCIES_PATH = "deficiencies/search";
const COMPANIES_PATH = "companies";

export const createDeficiency = async (payload: CreateDeficiencyRequestPayload): Promise<void> => {
  return api.post<void>(SERVICE, CREATE_DEFICIENCY_PATH, payload);
};

export const searchDeficiencies = async ({
  page,
  pageSize,
  body,
}: {
  page: number;
  pageSize: number;
  body: DeficiencySearchRequest;
}) => {
  return api.post<DeficiencySearchResponse>(
    SERVICE,
    `${SEARCH_DEFICIENCIES_PATH}?pageNumber=${page - 1}&pageSize=${pageSize}`,
    body,
  );
};

export const getBerthVisitedCodes = async (fromToLoc: string) => {
  return api.post<BerthVisitedCode[]>(SERVICE, "berths", { fromToLoc });
};

export const getCompanies = async () => {
  return api.get<DeficiencyCompany[]>(SERVICE, COMPANIES_PATH);
};

export const getDeficiencyById = async (
  deficiencyId: string,
): Promise<DeficiencyDetailsResponse> => {
  return api.get<DeficiencyDetailsResponse>(SERVICE, `deficiencies/${deficiencyId}`);
};

export const resolveDeficiencyById = async ({
  id,
  payload,
}: {
  id: string;
  payload: DeficiencyResolutionPayload;
}) => api.post<void>(SERVICE, `deficiencies/${id}/resolve`, payload);

export const claimDeficiencyById = ({ id }: { id: string }) =>
  api.post<void>(SERVICE, `deficiencies/${id}/claim`);

export const unclaimDeficiencyById = ({ id }: { id: string }) =>
  api.post<void>(SERVICE, `deficiencies/${id}/unclaim`);

export const completeDeficiencyById = ({
  id,
  payload,
}: {
  id: string;
  payload: DeficiencyCompletePayload;
}) => api.post<void>(SERVICE, `deficiencies/${id}/complete`, payload);
